/* pdp-descripcion.js — "Ver descripción completa" / "Ver menos" de la tarjeta
   de Descripción comercial (sections/pdp-descripcion.liquid).

   Comportamiento tomado del mockup aprobado: solo se alterna la clase
   `collapsed` sobre el cuerpo (max-height + degradado inferior en CSS) y la
   clase `open` sobre el botón (rota la flecha 180°). Nada más: sin translate,
   sin scale, sin rebote, sin sombras animadas, sin animación infinita.

   Se delega en document para que siga funcionando si el editor de temas
   reemplaza la sección, y es idempotente (no duplica listeners). */
(function () {
  'use strict';
  if (window.__pdpDescripcionInit) return;
  window.__pdpDescripcionInit = true;

  function toggle(btn) {
    var card = btn.closest('[data-pdp-descripcion]');
    if (!card) return;
    var body = card.querySelector('[data-desc-body]');
    var label = btn.querySelector('[data-desc-label]');
    if (!body) return;

    var collapsed = body.classList.toggle('collapsed');
    btn.classList.toggle('open', !collapsed);
    btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    if (label) {
      label.textContent = collapsed
        ? (btn.getAttribute('data-label-more') || 'Ver descripción completa')
        : (btn.getAttribute('data-label-less') || 'Ver menos');
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-desc-toggle]') : null;
    if (btn) toggle(btn);
  });

  // Si el texto es corto y no se recorta, el botón no aporta nada: se oculta.
  function hideUselessToggles() {
    var cards = document.querySelectorAll('[data-pdp-descripcion]');
    for (var i = 0; i < cards.length; i++) {
      var body = cards[i].querySelector('[data-desc-body]');
      var btn = cards[i].querySelector('[data-desc-toggle]');
      if (!body || !btn) continue;
      // scrollHeight real vs alto cerrado: si cabe completo, sobra el botón
      if (body.scrollHeight <= body.clientHeight + 4) {
        body.classList.remove('collapsed');
        btn.style.display = 'none';
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideUselessToggles);
  else hideUselessToggles();
})();
